'use client';

import { Dialog, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icons } from '@peerless/ui-assets/icons';
import { ProductImages, ProductImagesProps } from './ProductImages';

export interface ProductImagesModalProps extends ProductImagesProps {
  open: boolean;
  onClose(): void;
}

export function ProductImagesModal({ open, onClose, ...props }: ProductImagesModalProps) {
  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <ProductImages {...props} modal />
      <CloseButton size="large" onClick={onClose}>
        <FontAwesomeIcon fixedWidth icon={icons.close} />
      </CloseButton>
    </Dialog>
  );
}

const CloseButton = styled(IconButton)({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 100,
});
